// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-language-selector--container {
  border-radius: 8px;
  transition: background-color var(--transition-duration), box-shadow var(--transition-duration);
}
.menu-language-selector--container .menu-language-selector {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0rem 1rem;
  margin-left: 0.7rem;
}
.menu-language-selector--container .menu-language-selector--dropdown .p-dropdown {
  background-color: inherit;
}
.menu-language-selector--container .menu-language-selector--dropdown .p-dropdown-panel {
  background-color: white !important;
}

.menu-language-selector--container:hover {
  background-color: var(--root-menu-item-hover-bg);
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/menu-language-selector/menu-language-selector.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,8FAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AACR;AAEI;EACI,yBAAA;AAAR;AAGI;EACI,kCAAA;AADR;;AAKA;EACI,gDAAA;AAFJ","sourcesContent":[".menu-language-selector--container {\n    border-radius: 8px;\n    transition: background-color var(--transition-duration), box-shadow var(--transition-duration);\n\n    .menu-language-selector {\n        display: flex;\n        align-items: center;\n        gap: 2px;\n        padding: 0rem 1rem;\n        margin-left: 0.7rem;\n    }\n\n    .menu-language-selector--dropdown .p-dropdown {\n        background-color: inherit;\n    }\n\n    .menu-language-selector--dropdown .p-dropdown-panel {\n        background-color: white !important;\n    }\n}\n\n.menu-language-selector--container:hover {\n    background-color: var(--root-menu-item-hover-bg);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
